import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { choice } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import draggable from "vuedraggable";
import PicUpload from "@/components/picUpload/index.vue";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
let proportion = class proportion extends Vue {
  constructor() {
    super(...arguments);
    this.drag = false;
    this.loading = false;
    this.catalogList = [];
    this.editSortDialogKey = Math.random();
    this.postForm = {
      title: "请选择以下选项",
      required: "1",
      itemScore: 0,
      optionContentType: "TEXT",
      correctAnswer: ["1"],
      optionsList: [{
        value: "选项1",
        content: "选项1",
        rightOption: true,
        otherInput: false
      }, {
        value: "选项2",
        content: "选项2",
        rightOption: true,
        otherInput: false
      }],
      catalogIds: [],
      whetherJoinQuestionBank: false,
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        total: 100,
        otherInputForm: "NONE",
        otherInputNumberMin: null,
        otherInputNumberMax: null,
        otherInputNumberPrecision: null,
        otherInputMin: null,
        otherInputMax: null,
        selectRangeMin: null,
        selectRangeMax: null
      }
    };
    this.optionValidator = choice.content;
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        type: "string",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      itemScore: [{
        required: true,
        message: "请填写题目分值",
        trigger: "blur"
      }],
      optionsList: [{
        required: true,
        type: "array",
        validator: choice.optionsList
      }],
      // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
      whetherJoinQuestionBank: [{
        required: true,
        message: "请选择是否加入题库",
        trigger: "blur"
      }],
      "jsonConfig.selectRangeMin": [{
        validator: this.validatorSelectRange
      }],
      "jsonConfig.total": [{
        validator: this.validatorTotal
      }],
      otherInputForm: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      console.warn("postForm", this.postForm);
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  validatorSelectRange(rule, value, callback) {
    console.log("validatorSelectRange", "validatorSelectRange");
    if (this.postForm.jsonConfig.selectRangeMax && this.postForm.jsonConfig.selectRangeMin && this.postForm.jsonConfig.selectRangeMin > this.postForm.jsonConfig.selectRangeMax) {
      callback(new Error("最多应大于最少"));
    } else {
      callback();
    }
  }
  validatorTotal(rule, value, callback) {
    console.log("validatorTotal", value);
    const total = this.postForm.jsonConfig.total;
    if (total == "") {
      callback(new Error("总比重值不可为空"));
    } else if (total == 0) {
      callback(new Error("总比重值不可为0"));
    } else if (total < 0 || total.toString().includes(".")) {
      callback(new Error("仅可输入正整数"));
    } else if (total > 99999) {
      callback(new Error("最大99999"));
    } else {
      callback();
    }
  }
  get haveOtherSet() {
    return this.postForm.optionsList.some(ot => {
      return ot.otherInput;
    });
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  removeOption(item, index) {
    // let findIndex = this.postForm.correctAnswer.findIndex((answer: string) => {
    //   return answer == item.value;
    // });
    // if (findIndex >= 0) {
    //   this.postForm.correctAnswer.splice(findIndex, 1);
    // }
    this.postForm.optionsList.splice(index, 1);
    this.emitChange();
  }
  optionContentTypeChange() {
    this.postForm.optionsList.forEach(item => {
      item.content = "";
      item.otherInput = false;
    });
  }
  addOption(otherInput) {
    const str = this.postForm.optionContentType == "TEXT" ? "选项" + (this.postForm.optionsList.length + 1) : "";
    this.postForm.optionsList.push({
      value: str,
      content: otherInput ? "其它" : str,
      rightOption: false,
      otherInput: otherInput
    });
    this.emitChange();
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  validateOptions() {
    this.getFormInstance().validateField("optionsList");
  }
  validateTotal() {
    this.getFormInstance().validateField("total");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  remoteMethod(query) {
    this.loading = true;
    getCatalog({
      ...this.basicParams,
      name: query,
      pageSize: 50,
      pageNum: 1
    }).then(res => {
      this.catalogList = res.rows || [];
    }).finally(() => this.loading = false);
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  // $ 开始拖拽
  onStart() {
    this.drag = true;
  }
  // $ 结束拖拽
  onEnd() {
    this.drag = false;
    this.emitChange();
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], proportion.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], proportion.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], proportion.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], proportion.prototype, "watchPostForm", null);
proportion = __decorate([Component({
  name: "proportion",
  components: {
    PicUpload,
    questionSettingTemplate,
    draggable,
    EditSortDialog
  }
})], proportion);
export default proportion;